import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class CommonHttpApiService {
  constructor(private http: HttpClient) {}

  /* API call GET method to check for server is alive */
  checkBackedIsUp() {
    return this.http.get('').pipe(
      map((response) => {
        return response;
      })
    );
  }
}
